import {
  Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation
} from '@angular/core';
import { IBakery, IOrderLine, ngHelper, UiContextService } from '@cakeiteasy/web-utils';

import { ICartLine, cartHelper } from '../../../cart';
import { ICart } from '../../../cart/models/cart/i-cart';
import { ICakeCartLine } from '../../../cart/models/cart/i-cake-cart-line';
import { ICakeCartSourceMeta } from '../../../cart/models/cart/i-cake-cart-source-meta';
import { CART_DELIVERY_TYPES } from '../../../cart/constants/common';

import { ORDER_LINE_SOURCE } from '../../constants/common';

@Component({
  standalone: false,
  selector: 'cart-v2',
  templateUrl: './cart-v2.component.html',
  styleUrls: ['./cart-v2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CartV2Component implements OnChanges {
  @Input() cart: ICart;
  @Input() maxHeightReducer: number;
  @Input() isSideLayout = false;
  @Input() showDeliveryEdit = false;
  @Input() showReturnEdit = false;
  @Input() showBackBtn = false;
  @Input() showCloseBtn = true;

  @Output() onEditOrdered = new EventEmitter<{
    productTypeId: number,
    productTypeName?: string,
    orderLineBuilderId?: string,
    source?: string,
    sourceMeta?: ICakeCartSourceMeta,
    bakeryName?: string,
  }>();

  @Output() onBack = new EventEmitter<void>();
  @Output() onRemoveProduct = new EventEmitter<ICakeCartLine>();
  @Output() onCountUpdate = new EventEmitter<ICakeCartLine>();
  @Output() onContinue = new EventEmitter<void>();
  @Output() onEditDelivery = new EventEmitter<void>();
  @Output() onEditReturn = new EventEmitter<void>();
  @Output() onAddMoreClick = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();
  @Output() onClear = new EventEmitter<void>();

  public bakery: IBakery;
  public delivery: any;
  public cartCurrency: string;
  public orderLines: ICakeCartLine[];
  public quantity: number;
  public maxHeight: string;

  public CART_DELIVERY_TYPES = CART_DELIVERY_TYPES;

  constructor(private _ui: UiContextService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'maxHeightReducer', (value) => {
      const measurement = this._ui.isSm() ? '%' : 'vh';
      this.maxHeight = value ? `calc(100${measurement} - ${value}px)` : 'auto';
    });

    ngHelper.ifChanged(changes, 'cart', (cart: ICart) => {
      this.cart = cart;
      this.orderLines = this.cart.lines as ICakeCartLine[];
      this.delivery = this.cart.delivery;
      this.cartCurrency = cart.bakery && cart.bakery.country.currencySymbol;
      this.bakery = cart.bakery;

      this._setCartQuantity();
    });
  }

  public isImageSuitable(line: IOrderLine | ICartLine): boolean {
    return (line.product.type.image || line.product.type.categoryPictureId || line.product.image)
      && line.source !== ORDER_LINE_SOURCE.LANDING_PAGE;
  }

  public countUpdated(count: number, line: ICakeCartLine) {
    this.onCountUpdate.emit({
      ...line,
      count
    });
  }

  public removeProduct(line: ICakeCartLine) {
    this.onRemoveProduct.emit(line);
  }

  public editOrder(line: ICakeCartLine) {
    this.onEditOrdered.emit({
      productTypeId: line.parentType && line.orderLineBuilderId ? line.parentType : line.product.type.id,
      productTypeName: line.name,
      orderLineBuilderId: line.orderLineBuilderId,
      source: line.source,
      sourceMeta: line.sourceMeta,
      bakeryName: this.bakery.name,
    });
  }

  public trackByOrderLine(index: number, line: ICakeCartLine): string | number {
    return line.clientId || line.id || index;
  }

  public minQuantity(line: ICakeCartLine) {
    return cartHelper.getMinQuantityForOrderLine(line, this.orderLines);
  }

  public maxQuantity(line: ICakeCartLine) {
    return cartHelper.getMaxQuantityForOrderLine(line, this.orderLines);
  }

  private _setCartQuantity() {
    this.quantity = cartHelper.getQuantityFromOrderLines(this.orderLines);
  }
}
